<template>
  <BaseModal ref="modal">
    <UiModalDialog
      class="jps-modal search-history-modal"
      dialog-min-width="400px"
    >
      <template #header>
        {{ ls({ ja: '検索履歴', en: 'Search history' }) }}
      </template>
      <div class="jps-modal-content">
        <button class="jps-button clear-history" @click="clearHistory()">
          {{ lss('検索履歴のクリア', 'Clear History') }}
        </button>
        <UiConfirmModal ref="confirmModal" />
        <div>
          <p v-if="history.length === 0">
            {{ lss('検索履歴がありません。', 'There are no search histories') }}
          </p>
          <ul>
            <li
              class="jps-mysearch-query-view"
              v-for="(h, i) in history"
              :key="i"
            >
              <BaseLink
                :to="searchFromHistory(h)"
              >
                <SearchQuerySpan :q="h" />
              </BaseLink>
            </li>
          </ul>
        </div>
      </div>
      <template #buttons>
        <button @click="modal.reject()">{{ ls(dapLangGlobal.close) }}</button>
      </template>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
import type { BaseModal, UiConfirmModal } from '#components'

const { ls, lss } = useI18n()
const localSearchStore = useLocalSearchStore()

interface Props {
}
const props = withDefaults(defineProps<Props>(), {
})

const modal = ref<InstanceType<typeof BaseModal>>()
const openAwait = async () => {
  return await modal.value.openAwait()
}
defineExpose({ openAwait })

const history = computed(() => {
  return localSearchStore.history
})

const searchFromHistory = (q: SearchQuery) => {
  return `/csearch/${q.csid}${toSearchQueryString(q)}`;
}

const confirmModal = ref<InstanceType<typeof UiConfirmModal>>()
const clearHistory = async () => {
  try {
    const confirm = await confirmModal.value.openAwait({
      message: dapLangGlobal.deleteConfirm,
      messageVars: [ls({ja: '全ての履歴', en: 'All histories'})]
    })
    if (!confirm) return
    localSearchStore.clearHistory()
  } catch (cancel) {}
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

button {
  width: 100%;
}

.search-history-modal {
  background-color: $jps-gray-50;
}

.jps-mysearch-default-search {
  padding: 0.5rem;
  @include box-shadow();
  margin-bottom: 1rem;
  background: $jps-key-blue;
  color: white;
}
.jps-mysearch-config {
  h2:not(:first-child) {
    margin-top: 2.5rem;
  }
  h2 {
    i {
      cursor: pointer;
    }
  }
}
.jps-mysearch-choice-list {
  margin: 1rem 0;
  span.jps-cs-span {
    @include is-tablet {
      min-width: 16rem;
      display: inline-block;
    }
  }
  .jps-current-mysearch {
    background: $jps-key-blue;
    color: $white;
    font-size: $size-7;
    display: inline-block;
    padding: calc(0.375em - 1px) 0.75rem;
    border: 1px solid $jps-key-blue;
    text-align: center;
  }
  .jps-current-mysearch,
  .jps-mysearch-choice {
    width: 12rem;
    @include is-mobile {
      width: 100%;
      margin-top: 0.5rem;
    }
  }
}
.jps-mysearch-query-view {
  /* cursor: pointer; */
  padding: 0.5rem;
  margin: 0.5rem 0;
  @include box-shadow();
  background: white;
  @include is-mobile {
    display: flex;
    flex-direction: column;
  }
}
.clear-history {
  margin-bottom: 1rem;
  }
</style>
